// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"87":"a1ee324578b02919","5390":"cf51b03f9ed5d6ed","6488":"3ce42c46b258faf8","8404":"de281bc6edd7dcec"}[chunkId] + ".css";
};